module.exports = __webpack_public_path__ + "media/images/tours/2022-05-03/geosearch-1-e35cc4680a01bda1449f7749d2225b37.jpg";